import * as React from 'react';
import { Team, TradeProposalPlayer, Player, TeamPlayerInfo } from '../../../sdk/model';
import {TableRow, TableCell, TextField, IconButton, Collapse, Typography, Tooltip} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import InfoIcon from '@mui/icons-material/Info';
import { toSalary } from '../../util/SalaryDisplay';
import MoneyFormat from '../../util/MoneyFormat';

interface playerTradeDeadCapBalanceProps {
  proposalPlayer : TradeProposalPlayer,
  playerMap: Map<string | undefined, Player | undefined>,
  teamMap: Map<string | undefined, Team>,
  teamPlayerMap: Map<string | undefined, TeamPlayerInfo | undefined>,
  currentSeason: number | undefined,
  handleDeadCapChange: Function,
}

function PlayerTradeDeadCapBalance(props: playerTradeDeadCapBalanceProps) {
  const MINIMUM_DEAD_CAP_INCREMENT = 100000;
  
  function remainingSalaries(teamPlayer: TeamPlayerInfo, tradedPlayer : TradeProposalPlayer) {
    return teamPlayer?.contract?.seasons?.map(contractSeason => 
      contractSeason ? contractSeason.weeks!.flatMap(week => week.payments).filter(payment => payment && !payment.completed && payment.teamId).reduce((partialSum, payment) => partialSum + payment?.price!, 0) : 0
    );
  }
  
  function onChange(event, playerId: string, contractSeason: number, max: number) {
    let value = Number(event.target.value);
    if (value > max) {
      value = max;
    } else if (value < 0){
      value = 0;
    }
    props.handleDeadCapChange(playerId, contractSeason, value)
  }

  const [open, setOpen] = React.useState(false);
  const fromTeam = props.teamMap.get(props.proposalPlayer.fromTeamId);
  const player = props.playerMap.get(props.proposalPlayer.playerId);
  const toTeam = props.teamMap.get(props.proposalPlayer.toTeamId);
  const teamPlayer = props.teamPlayerMap.get(props.proposalPlayer.playerId)!;
  const remainingSalaryValues = remainingSalaries(teamPlayer, props.proposalPlayer)!;
  const totalRemainingSalary = remainingSalaryValues.reduce((sum, salary) => sum + salary, 0);
  const totalTeamDeadCapPayout = Object.values(props.proposalPlayer.tradingTeamDeadCapPayouts!).filter(payout => payout).reduce((sum, payout) => sum + payout, 0);
  const remainingCapHit = totalRemainingSalary - totalTeamDeadCapPayout;
  return <React.Fragment>
    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
      <TableCell>
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
        >
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </TableCell>
      <TableCell>{player?.abbr_name}</TableCell>
      <TableCell>{fromTeam?.name}</TableCell>
      <TableCell>{toSalary(totalTeamDeadCapPayout)}</TableCell>
      <TableCell>{toTeam?.name}</TableCell>
      <TableCell>{toSalary(remainingCapHit)}</TableCell>
    </TableRow>
    <TableRow>
      <TableCell colSpan={6}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Typography variant="h6" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>
            Trading Team Dead Cap Hit(s) <Tooltip title="The team trading away a player can agree to immediately pay a portion of that player's salary and take that cap hit toward a year on the player's contract.  This would relieve the receiving team of that cap hit burden."><InfoIcon /></Tooltip>
          </Typography>
          {teamPlayer?.contract?.seasons?.map((contractSeason, seasonIndex) => 
           contractSeason.season_year! < props.currentSeason! ? null :
            <TextField key={seasonIndex} name="deadCap" label={contractSeason.season_year} value={props.proposalPlayer.tradingTeamDeadCapPayouts![contractSeason.season_year!.toString()]}
                InputProps={{inputProps: {min: 0, max: totalRemainingSalary[seasonIndex], step:MINIMUM_DEAD_CAP_INCREMENT}, inputComponent: MoneyFormat as any}} onChange={event => onChange(event, props.proposalPlayer.playerId!, contractSeason.season_year!, remainingSalaryValues[seasonIndex])}/>
          )}
        </Collapse>
      </TableCell>
    </TableRow>
  </React.Fragment>
}
  
export default PlayerTradeDeadCapBalance;
